module.exports = __webpack_public_path__ + "img/owl-pink-back.fd85981b.png";